import { Card, List, Space, Tooltip, Typography } from "antd";
import {
  SettingOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Meta from "antd/es/card/Meta";

const { Text } = Typography;

const EpisodeCard = (props) => {
  const {
    episode,
    serie,
    seasonIndex,
    onClickEdit,
    onClickSettings,
    onClickDelete,
  } = props;

  console.log("EPISODE CARD :", episode);

  const description = () => {
    return (
      <Space direction="vertical" wrap>
        <Text>EP{episode.number}</Text>
        <Space size={"small"} direction="vertical">
          <Text type="secondary">Auteur: {episode.author}</Text>
          <Text type="secondary">Illustrateur: {episode.illustrator}</Text>
        </Space>
        <Text type={episode.statut === "unavailable" ? "danger" : "success"}>
          {episode.statut}
        </Text>
      </Space>
    );
  };

  return (
    <List.Item>
      <Card
        cover={
          <img
            alt="example"
            src={
              episode.img
                ? `https://newbrand.s3.eu-west-3.amazonaws.com/series/${
                    serie.uid
                  }/season-${seasonIndex + 1}/ep-${episode.number}/img/${
                    episode.img
                  }`
                : null
            }
          />
        }
        actions={[
          <EditOutlined onClick={onClickEdit} key="edit" />,
          <SettingOutlined onClick={onClickSettings} key="setting" />,
          <DeleteOutlined
            onClick={() => {
              onClickDelete(episode.id);
            }}
            key="delete"
          />,
        ]}
      >
        <Meta title={`${episode.name}`} description={description()} />
        <div
          style={{
            top: 0,
            right: 0,
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            padding: 10,
            borderRadius: 10,
          }}
        >
          <Tooltip
            title={`Épisode ${
              episode.startingNode === null ? "non " : ""
            }intégré`}
          >
            <div
              style={{
                width: 15,
                aspectRatio: 1,
                borderRadius: 200,
                border: "2px solid white",
                backgroundColor:
                  episode.startingNode === null ? "#ff0000" : "#00ff00",
              }}
            />
          </Tooltip>
        </div>
      </Card>
    </List.Item>
  );
};

export default EpisodeCard;
